import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

export const TICK_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};

export default class TimelineElement extends PureComponent {
  static propTypes = {
    tickPosition: PropTypes.oneOf([ TICK_POSITIONS.LEFT, TICK_POSITIONS.RIGHT ]),
    className: PropTypes.string
  }

  static defaultProps = {
    tickPosition: TICK_POSITIONS.RIGHT,
    className: ''
  }

  render() {
    return <div className={`timeline-element ${this.props.tickPosition ? 'tick-' + this.props.tickPosition : ''} ${this.props.className}`}>
      {this.props.children}
    </div>;
  }
}
